import { render, staticRenderFns } from "./AssignOrdersDeliveryRider.vue?vue&type=template&id=472cd41a&scoped=true&"
import script from "./AssignOrdersDeliveryRider.vue?vue&type=script&lang=js&"
export * from "./AssignOrdersDeliveryRider.vue?vue&type=script&lang=js&"
import style0 from "./AssignOrdersDeliveryRider.vue?vue&type=style&index=0&id=472cd41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472cd41a",
  null
  
)

export default component.exports